import Vue from 'vue'
import LoadingPlugin from '@/components/loading/plugin'

Vue.use(LoadingPlugin)
